module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ('height: 100vh;background:url(' + _vm.row.show_banjiang_pic_url + ') no-repeat;background-size:100%;')
  }, [_c('div', {
    staticClass: "machine-head",
    staticStyle: {
      "visibility": "hidden",
      "font-size": "60px",
      "letter-spacing": "10px",
      "height": "360px",
      "line-height": "120px",
      "text-shadow": "2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000",
      "position": "relative"
    },
    style: ({
      'color': '#fff',
      'background': '#ea0000'
    })
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "margin-right": "10px",
      "position": "absolute"
    },
    attrs: {
      "src": _vm.row.score_logo ? _vm.row.score_logo : 'https://wa.ccachina.net/img/logo.58b57af4.png'
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.row.saiqu_name) + "\n      ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100px",
      "position": "absolute",
      "float": "right",
      "top": "20px",
      "right": "20px"
    },
    attrs: {
      "src": "https://wa.ccachina.net/img/logo.58b57af4.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "rgba(255,255,255,0.74)",
      "border": "10px solid rgba(164,208,255,0.43)",
      "border-radius": "20px",
      "margin-left": "20px",
      "margin-right": "20px",
      "height": "100px",
      "letter-spacing": "0.2em",
      "text-shadow": "2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white",
      "line-height": "100px",
      "margin-bottom": "10px",
      "text-align": "center",
      "color": "#000",
      "font-size": "48px",
      "padding": "0px 20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.start.subject_name))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list['1'].length > 0),
      expression: "list['1'].length>0"
    }],
    staticStyle: {
      "text-align": "center",
      "height": "auto",
      "line-height": "140px",
      "margin": "10px",
      "color": "#e64449",
      "font-size": "80px",
      "padding": "0",
      "text-shadow": "2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white",
      "font-weight": "bold"
    }
  }, [_vm._v(" 第一名"), _c('br'), _vm._v(" "), _vm._l((_vm.list['1']), function(ivalue, ikey) {
    return _c('p', {
      key: ikey
    }, [_vm._v(_vm._s(ivalue.danwei))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "machine-box",
    staticStyle: {
      "margin": "10px",
      "height": "100%"
    },
    style: ({
      'color': _vm.row.show_font_color
    })
  }, [_c('div', {
    staticClass: "machine-content"
  }, [_c('table', {
    staticClass: "machine-table",
    style: ({
      'color': _vm.row.show_font_color_2
    })
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "color": "#e64449",
      "text-shadow": "2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white"
    }
  }, [_c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list['2'].length > 0),
      expression: "list['2'].length>0"
    }]
  }, [_vm._v("第二名"), _c('br'), _vm._v(" "), _vm._l((_vm.list['2']), function(ivalue, ikey) {
    return _c('p', {
      key: ikey,
      staticStyle: {
        "font-size": "60px"
      }
    }, [_vm._v(_vm._s(ivalue.danwei))])
  })], 2), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list['3'].length > 0),
      expression: "list['3'].length>0"
    }]
  }, [_vm._v("\n              第三名"), _c('br'), _vm._v(" "), _vm._l((_vm.list['3']), function(ivalue, ikey) {
    return _c('p', {
      key: ikey,
      staticStyle: {
        "font-size": "60px"
      }
    }, [_vm._v(_vm._s(ivalue.danwei))])
  })], 2)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25f616a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/score/ScoreAwardList.vue
// module id = 2276
// module chunks = 0